import { getPerformanceApi } from './performanceApi';
export const markExists = mark => {
  const perfApi = getPerformanceApi();
  if (!perfApi) {
    return false;
  }
  const markEntry = perfApi.getEntriesByName(mark.name, 'mark');
  return markEntry && markEntry.length > 0;
};